import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../retailer.service';
import { DeleteRetailerComponent } from './delete-retailer/delete-retailer.component';

@Component({
  selector: 'app-close-retailers',
  templateUrl: './close-retailers.component.html',
  styleUrls: ['./close-retailers.component.scss'],
  providers: [CurrencyPipe]
})
export class CloseRetailersComponent extends FeaturesBaseComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  defaultColDef: { editable: boolean; sortable: boolean; filter: boolean; resizable: boolean; pagination: boolean; paginationAutoPageSize: boolean; };
  columnDefs: any[];
  rowData: any[];
  searchValue: any;
  retailerId: any = 3;
  showDeleteRetailer: boolean;
  retailerInfo: any[];
  retailerDetails: any;
  selectedRetailerInfo: any;
  constructor(private retailerService: RetailerService, private dialog: MatDialog
   , private currencyPipe: CurrencyPipe, private router: Router) {
    super();

    this.defaultColDef = {
      editable: false,
      sortable: true,
      filter: false,
      resizable: true,
      pagination: true,
      paginationAutoPageSize: true,
    };
    this.columnDefs = [
      { field: 'retailerId', headerName: 'retailerId', width: 0, hide: true, sort: "desc" },
      { field: 'null', headerName: 'Action', width: 110, checkboxSelection: true },
      { field: 'retailerAccountNum', headerName: 'Account #', width: 150 },
      // { field: 'dbaName', headerName: 'Retailer Name', width: 150 },
      { field: 'dbaName', headerName: 'DBA Name', width: 150 },
      { field: 'retailerType', headerName: 'Account Type', width: 180 },
      { field: 'businessName', headerName: 'Business Name', width: 180 },
      // { field: 'retailerPaymentStatus', headerName: 'Refund Status', width: 150 },
      { field: 'retailerStatusReason', headerName: 'Reason For Closing', width: 210 },
      { field: 'currentAmount', headerName: 'Payment Balance', width: 210, cellRenderer: (params) => {
       
        return params.data.retailerType.toLowerCase() == 'prepaid' ? this.currencyPipe.transform(params.value) : this.currencyPipe.transform(params.data.invoiceDue)
      }},
      { field: 'paymentOptionType', headerName: 'Payment Type', width: 210 },
      { field: '', headerName: 'Close Action', width: 170, pinned: "right", cellRenderer: (params) => {
        return `<span class="badge rounded-pill bg-danger fs-6"> Reject</span>`
      },onCellClicked:  (params) =>{
        this.retailerService.cancelRetailerCloseAccount(params?.data?.retailerId).subscribe(res => {
          this.toastrService.info(`Close account reverted`)
          let currentUrl = this.router.url;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = "reload";
          this.router.navigate([currentUrl]);
        })
      }},
      { field: 'createdDttm', headerName: 'createdDttm', width: 210, hide: true, },
      { field: 'currentAmount', headerName: 'currentAmount', width: 210, hide: true, },
      { field: 'invoiceDue', headerName: 'invoiceDue', width: 210, hide: true, },
      { field: 'paymentOptionType', headerName: 'paymentOptionType', width: 210, hide: true, },
      { field: 'paymentStatus', headerName: 'paymentStatus', width: 210, hide: true, },
      { field: 'retailerAccountNum', headerName: 'retailerAccountNum', width: 210, hide: true, },
      { field: 'salesRepName', headerName: 'salesRepName', width: 210, hide: true, },
      
    ]
  this.getCloseRequests();
  }
  private getCloseRequests() {
    this.retailerService.getCloseAccountRequests().subscribe(
      res => {
        if (res['httpcode'] == 200) {
          this.retailerInfo = res.data;
          this.retailerDetails = [];
          this.retailerInfo.forEach(e => {
            e['retailerDetails']['retailerAccountNum'] = e.retailerAccountNum
            e['retailerDetails']['salesRepName'] = e.salesRepName
            e['retailerDetails']['currentAmount'] = e.currentAmount
            e['retailerDetails']['paymentOptionType'] = e.paymentOptionType
            e['retailerDetails']['paymentStatus'] = e.paymentStatus
            if (e['retailerDetails'].retailerType == 'Postpaid'){
              e['retailerDetails']['invoiceDue'] = e.invoiceDue
            }
            this.retailerDetails.push(e['retailerDetails'])
          })
        }
      }
    )
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);

  }
  ngOnInit(): void {
    super.ngOnInit()
 
 
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }



  // event on row selection change
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0) {
      this.showDeleteRetailer = true;
      this.retailerId = this.selectedRows[0].retailerId;
      this.selectedRetailerInfo = this.selectedRows[0];
      return
    }
    this.showDeleteRetailer = false;
  }

  onCloseRetailer(retailerInfo){
    const dialogRef = this.dialog.open(DeleteRetailerComponent, { width: '60vw', data: {'retailerInfo': retailerInfo}})

    dialogRef.afterClosed().subscribe(result => {
     
      this.getCloseRequests()
    });
  }

}
